import { error } from '../actions';
import { getLandingPageAccess } from '../services/landingPageAccess.service';
import { LandingPageAccess } from '../types/userTeamAccess.types';
import { AxiosResponse } from 'axios';
import { put, retry, takeLatest } from 'redux-saga/effects';
import {
	requestLandingPageAccess,
	requestLandingPageAccessRejected,
	requestLandingPageAccessResolved,
} from '../actions/landingPageAccess.actions';

function* getLandingPageSaga() {
	try {
		const response: AxiosResponse<LandingPageAccess> = yield retry(
			2,
			10000,
			getLandingPageAccess,
		);
		if (response.data) {
			yield put(requestLandingPageAccessResolved(response.data));
		} else {
			yield put(requestLandingPageAccessRejected());
			yield put(error('Failed to get landing page access'));
		}
	} catch (e) {
		yield put(requestLandingPageAccessRejected());
		yield put(error('Failed to get landing page access'));
	}
}

function* watchGetLandingPageSaga() {
	yield takeLatest(requestLandingPageAccess, getLandingPageSaga);
}

export default [watchGetLandingPageSaga()];
